import type { FaireProductEntity } from "../../entity_types/product";

export const p_9myzne5heu: FaireProductEntity = {
  token: "p_9myzne5heu",
  type: "product",
  name: 'Mini Tumbled Citrine Crystals - 36 pcs, .5"',
  brandToken: "b_23c7bc37",
  brandName: "GeoCentral",
  imageUrl:
    "https://cdn.faire.com/fastly/33ecf2e48570efc410799e4cb9da82ffd04d43f6d8220c185a02b9bdf16a4684.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88454fa5670ff25bcc8d49f10f94a748889872f2b1651b734f3970eecda660b4.jpeg",
  ],
  priceDollars: 0.69,
  description:
    "- Citrine boosts optimism + clarity! \n- Our assortment of mini crystals are .5” And perfect for carrying in a small bag, keeping in a pocket, or crystal grid making. \n- You will find that the variety and quality of our crystals transform one-item customers into multiple-item collectors! \n- For add-on sales, supplement this new product with bags, crystal grids, and loose tools.\n\nWholesale Crystals | Crystals for Beginners | Introductory Crystals | Souvenir Crystals | Educational Crystals | Geological | Metaphysical | Crystal Properties",
  tags: [],
  msrpDollars: 1.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:59.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
